import { action, orchestrator } from 'satcheljs';
import { getCurrentSubcategory } from 'owa-options-store';
import {
    lazyConfirmOptionNavigation,
    isAnyOptionDirty,
    shouldDisableSaveButton,
} from 'owa-options-core';
import { saveOptions, discardOptions } from 'owa-options-orchestration';

function executeCallbackAndHide(
    saveDiscardCallback: () => void,
    continueAfterConfirmCallback: () => void
) {
    if (saveDiscardCallback) {
        saveDiscardCallback();
    }

    continueAfterConfirmCallback();
}

const confirmDirtyOptionsAndPerformAction = action(
    'confirmDirtyOptionsAndPerformAction',
    (continueAfterConfirmCallback: () => void, continueAfterCancelCallback?: () => void) => ({
        continueAfterConfirmCallback,
        continueAfterCancelCallback,
    })
);

export default confirmDirtyOptionsAndPerformAction;

orchestrator(confirmDirtyOptionsAndPerformAction, actionMessage => {
    const continueAfterConfirmCallback = actionMessage.continueAfterConfirmCallback;
    let currentSubcategory = getCurrentSubcategory();
    if (isAnyOptionDirty(currentSubcategory)) {
        lazyConfirmOptionNavigation.importAndExecute({
            onSave: () => {
                executeCallbackAndHide(saveOptions, continueAfterConfirmCallback);
            },
            onDiscard: () => {
                executeCallbackAndHide(discardOptions, continueAfterConfirmCallback);
            },
            onCancel: actionMessage.continueAfterCancelCallback,
            shouldDisableSaveButton: shouldDisableSaveButton(currentSubcategory),
        });
    } else {
        continueAfterConfirmCallback();
    }
});
